(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.BulkDeleteService = (function(superClass) {
    extend(BulkDeleteService, superClass);

    function BulkDeleteService(http, modal, state) {
      this.http = http;
      this.modal = modal;
      this.state = state;
      this.launchDialog = bind(this.launchDialog, this);
      this.deleteSelected = bind(this.deleteSelected, this);
      this.selectRow = bind(this.selectRow, this);
      this.setRowClasses = bind(this.setRowClasses, this);
      this.activate = bind(this.activate, this);
      this.deactivate = bind(this.deactivate, this);
      this.toggle = bind(this.toggle, this);
      this.updateButtonInfo = bind(this.updateButtonInfo, this);
      this.active = false;
      this.buttonText = '';
      this.buttonIcon = '';
      this.selected = [];
      this.unselectedClass = 'success';
      this.selectedClass = 'error';
      this.updateButtonInfo();
    }

    BulkDeleteService.prototype.updateButtonInfo = function() {
      this.buttonText = 'Delete';
      this.buttonIcon = 'fa-trash-alt';
      if (this.active) {
        this.buttonText = 'Cancel Deletion';
        this.buttonIcon = 'fa-remove';
      }
      if (this.active && this.selected.length) {
        this.buttonText = 'Delete Selected';
        return this.buttonIcon = 'fa-trash-alt';
      }
    };

    BulkDeleteService.prototype.toggle = function(fieldprints) {
      this.fieldprints = fieldprints;
      if (this.active) {
        this.deactivate();
        return;
      }
      return this.activate();
    };

    BulkDeleteService.prototype.deactivate = function() {
      if (this.selected.length) {
        this.deleteSelected();
      }
      this.active = false;
      this.selected = [];
      this.setRowClasses();
      return this.updateButtonInfo();
    };

    BulkDeleteService.prototype.activate = function() {
      this.active = true;
      return this.updateButtonInfo();
    };

    BulkDeleteService.prototype.setRowClasses = function(selected) {
      var i, len, ref, results, row;
      if (selected == null) {
        selected = false;
      }
      ref = this.fieldprints;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        results.push(row.selected_for_delete = selected);
      }
      return results;
    };

    BulkDeleteService.prototype.selectRow = function(row, fieldprints) {
      if (row.selected_for_delete) {
        this.selected.splice(this.selected.indexOf(row), 1);
      } else {
        this.selected.push(row);
      }
      row.selected_for_delete = !row.selected_for_delete;
      return this.updateButtonInfo();
    };

    BulkDeleteService.prototype.deleteSelected = function() {
      var dialog;
      dialog = this.launchDialog({
        multiple: this.selected.length > 1,
        selected: this.selected
      });
      return dialog.result.then((function(_this) {
        return function(response) {
          return _this.state.go('grower.fieldprint', null, {
            reload: 'grower.fieldprint'
          });
        };
      })(this));
    };

    BulkDeleteService.prototype.launchDialog = function(resolve) {
      return this.modal.open({
        windowClass: 'sm_dialog',
        templateUrl: 'backend/grower/fieldprint/bulk-delete',
        controller: 'Fieldprint.Controllers.BulkDeleteController',
        resolve: {
          'Data': (function(_this) {
            return function() {
              return resolve;
            };
          })(this)
        }
      });
    };

    return BulkDeleteService;

  })(Service);

}).call(this);
